export const TYPE_JOB_TITLE = "job_title";
